export default {
  newVersion: {
    updated: "HelixScan has been updated to {version}",
    reload: "Reload",
  },
};
